export default {
  'introThanks': '¡Gracias por su colaboración, sus comentarios nos ayudan a mejorar!',
  'customerFirstname': 'Nombre',
  'customerLastname': 'Apellido',
  'customerEmail': 'E-Mail',
  'customerTitle': 'Título',
  'visitFrom': 'Día de llegada',
  'visitTo': 'Día de salida',
  'visitRoom': 'Número de habitación',
  'salutationOptionMr': 'Señor',
  'salutationOptionMrs': 'Señora',
  'salutationOptionFamily': 'Familia',
  'btnStart': 'Empezar',
  'thanksTitle': '¡Muchas gracias!',
  'thanksTextFinish': 'El cuestionario, si tiene prisa, ahora lo puede ...',
  'thanksBtnFinish': 'Finalizar',
  'thanksTextContinue': '... pero si le quedan unos minutos de tiempo, nos gustaría hacerle unas preguntas más detalladas',
  'thanksBtnContinue': 'Más preguntas',
  'selectChooseOption': 'Por favor seleccione una opción',
  'btnNext': 'Continuar',
  'btnSkip': 'Saltar',
  'btnFeedback': 'Comentario',
  'selectorTextThanks': '¡Genial, muchas gracias por su ayuda!',
  'selectorTextSelect': '¿Cuál de las ofertas citadas a continuación usó?',
  'feedbackTitle': 'Sus comentarios en relación con el tema',
  'feedbackPositiveTitle': '¿Qué era positivio?',
  'feedbackNegativeTitle': '¿Qué era negativo?',
  'smileyVeryHappy': 'Muy bien',
  'smileyHappy': 'Bien',
  'smileyMedium': 'Normal',
  'smileyUnhappy': 'Mal',
  'smileyVeryUnhappy': 'Muy mal',
  'smileyNotScored': 'Sin valorar',
  'validationMessageEmail': 'Por favor introduzca una cuenta de correo válida',
  'validationMessageRequired': '"Campo obligatorio"',
  'txtAppStart': 'Cargando cuestionario...',
  'selectorTitle': 'Uso de nuestras ofertas',
  'finalThanksTitle': 'Gracias por sus sugerencias',
  'finalThanksHolidayCheckIntro': '¿Nos permite compartir parte de sus valoraciones con HolidayCheck?<br />¡Nos haría un gran favor! En la siguiente página le mostraremos un resumen de sus datos, que, solamente con su permiso, transferiríamos a HolidayCheck.<br /><br />Sólo son unos pocos clics y revisiones - entonces habrá finalizado.',
  'finalThanksHolidayCheckBtn': 'HolidayCheck – Mostrar resumen',
  'pickDate': 'Seleccionar fecha',
  'surveyFinishedTitle': 'Cuestionario terminado',
  'surveyAlreadyDone': '¡Ya participó en esta encuesta, muchas gracias!',
  'legendPrimerPositive': 'completamente satisfecho',
  'legendPrimerNegative': 'muy insatisfecho',
  'hcTitle_recommendation': 'Empfehlen Sie das Hotel weiter?',
  'hcTitle_title': '¿Cuál es el título de su cuestionario?',
  'hcTitle_text': 'Describa el hotel en general',
  'hcDescription_text': 'Describa en 2 a 3 párrafos su primera impresión del hotel. Por ejemplo, ¿fue adecuado para su motivo del viaje?',
  'hcFilledHint': 'Por favor rellene todos los campos',
  'hcTitle_age': '¿Cuántos años tiene?',
  'hcTitle_traveledWith': '¿Con quién a viajado?',
  'hcTitle_travelDuration': 'Duración de la estancia',
  'hcOption_traveledWith_friends': 'Amigos',
  'hcOption_traveledWith_family': 'Familia',
  'hcOption_traveledWith_couple': 'Pareja',
  'hcOption_traveledWith_single': 'Solo',
  'hcOption_children_no': 'ninguno',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'más de 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Muy mal',
  'hcOption_ratingCostPerformance_bad': 'Más bien mal',
  'hcOption_ratingCostPerformance_medium': 'Razonable',
  'hcOption_ratingCostPerformance_good': 'Bien',
  'hcOption_ratingCostPerformance_great': 'Muy bien',
  'hcOption_travelReason_business': 'Negocio',
  'hcOption_travelReason_city': 'Ciudad',
  'hcOption_travelReason_wellness': 'Bienestar',
  'hcOption_travelReason_winter': 'Invierno',
  'hcOption_travelReason_other': 'Otros',
  'hcOption_travelReason_beach': 'Playa',
  'hcOption_travelDuration_1-3 days': '1-3 días',
  'hcOption_travelDuration_3-5 days': '3-5 días',
  'hcOption_travelDuration_1 week': '1 semana',
  'hcOption_travelDuration_2 weeks': '2 semanas',
  'hcOption_travelDuration_3 weeks': 'Más de 2 semanas',
  'hcCardTitle': 'Transferencia de valoración a Holidaycheck',
  'btnSubmit': 'Remitir',
  'requiredField': 'Campo obligatorio',
  'topicTitle': '¿Tema diferente?',
  'topicHint': 'Seleccione el tema del que desea escribir un comentario',
  'txtSuggestFeedback': 'Su comentario al respecto sería genial :-)',
  'txtFiguresPercent': 'Cifras en porcentajes',
  'txtImpress': 'Aviso legal',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Política de privacidad',
  'txtPrivacyConsent': 'Acepto que lo datos de la encuesta sean guardados y procesados para mejorar la calidad. Los datos serán eliminados pasados los 24 meses desde la encuesta. Puede revocar el permiso en cualquier momento con un correo electrónico a <a href="mailto:%{mail}">%{mail}</a>. Información detallada sobre el procesamiento de datos de usuario se encuentra en nuestra <a href="%{link}" target="_blank">política de privacidad</a>.',
  'txtPrivacyHint': 'Acepto que mi reseña sea publicada en las páginas web del negocio y en la página de reseñas <a href="%{link}" target="_blank">%{link}</a>, junto con mi sexo, mi nombre abreviado, mi localidad y la fecha de publicación de la misma. Este consentimiento puedo revocarlo en cualquier momento en <a href="mailto:%{mail}">%{mail}</a> y se procederá a eliminar dicha reseña.',
  'txtExample': 'Ejemplo',
  'txtSkip': 'Saltar',
  'txtPrivacyValidationHint': 'Sin su consentimiento no podemos tramitar el texto',
  'btnDifferentTopic': 'Tema diferente'
}



// WEBPACK FOOTER //
// ./src/languages/es.js